import React, { useEffect, useState } from 'react';
import "./TosPage.css"
const TosPage = () => {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Check system preference on mount
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      setTheme('dark');
    }

    // Listen for system theme changes
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setTheme(e.matches ? 'dark' : 'light');
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const toggleTheme = () => {
    setTheme(prevTheme => prevTheme === 'light' ? 'dark' : 'light');
  };

  return (
    <div className={`tos-container ${theme}`}>
      <div className="theme-toggle">
        <button onClick={toggleTheme}>
          {theme === 'light' ? '🌙' : '☀️'}
        </button>
      </div>
      
      <div className="tos-content">
        <h1>Terms of Service</h1>
        <p className="last-updated">Last Updated: October 29, 2024</p>

        <section>
          <h2>1. Introduction</h2>
          <p>Welcome to JourneyAI ("we," "our," or "us"). By accessing or using our mobile application and services, you agree to be bound by these Terms of Service ("Terms"). Please read these Terms carefully before using JourneyAI.</p>
        </section>

        <section>
          <h2>2. Services Description</h2>
          <p>JourneyAI provides an AI-powered journaling platform that includes:</p>
          <ul>
            <li>Digital journaling capabilities</li>
            <li>AI-powered writing assistance and insights</li>
            <li>Emotional tracking and analysis</li>
            <li>Personalized writing prompts</li>
            <li>Data encryption and security features</li>
          </ul>
        </section>

        <section>
          <h2>3. Account Registration</h2>
          <p>To use JourneyAI, you must:</p>
          <ul>
            <li>Be at least 4 years of age</li>
          </ul>
        </section>

        <section>
          <h2>4. Privacy and Data Protection</h2>
          <p>We prioritize your privacy and protect your data through:</p>
          <ul>
            <li>End-to-end encryption of journal entries</li>
            <li>Secure local storage options</li>
            <li>Strict data handling procedures</li>
            <li>Compliance with applicable privacy laws</li>
          </ul>
        </section>

        <section>
          <h2>5. AI Features and Content</h2>
          <p>Regarding our AI features:</p>
          <ul>
            <li>AI insights are generated using advanced algorithms</li>
            <li>We do not guarantee the accuracy of AI-generated content</li>
            <li>AI suggestions should not be considered professional advice</li>
            <li>You retain ownership of your journal entries</li>
          </ul>
        </section>

        <section>
          <h2>6. User Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Violate any laws or regulations</li>
            <li>Infringe on intellectual property rights</li>
            <li>Share harmful or inappropriate content</li>
            <li>Attempt to breach our security measures</li>
            <li>Use the service for unauthorized commercial purposes</li>
          </ul>
        </section>

        <section>
          <h2>7. Subscription and Billing</h2>
          <p>Our subscription terms include:</p>
          <ul>
            <li>Automatic renewal unless cancelled</li>
            <li>Pricing subject to change with notice</li>
            <li>Refunds per platform store policies</li>
            <li>Cancellation available anytime</li>
          </ul>
        </section>

        <section>
          <h2>8. Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that:</p>
          <ul>
            <li>Violate these Terms</li>
            <li>Engage in fraudulent activity</li>
            <li>Pose a risk to other users</li>
            <li>Remain inactive for extended periods</li>
          </ul>
        </section>

        <section>
          <h2>9. Disclaimers</h2>
          <p>JourneyAI is provided "as is" and we make no warranties regarding:</p>
          <ul>
            <li>Uninterrupted service availability</li>
            <li>Accuracy of AI-generated content</li>
            <li>Fitness for particular purposes</li>
            <li>Third-party integrations</li>
          </ul>
        </section>

        <section>
          <h2>10. Contact Information</h2>
          <p>For questions about these Terms, contact us at:</p>
          <div className="contact-info">
            <p>Email: nikiemaadama249@gmail.com</p>
          </div>
        </section>

        <div className="tos-footer">
          <p>© 2024 JourneyAI. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default TosPage;